import { QuickAddSheet } from "./sheet";

declare global {
  interface Window {
    quickViewInstance?: QuickAddSheet;
  }
}

let instance: QuickAddSheet | null = null;

export function initQuickAddSheet(): QuickAddSheet | null {
  if (window.quickViewInstance) {
    return window.quickViewInstance;
  }

  instance = new QuickAddSheet();
  window.quickViewInstance = instance;
  return instance;
}

export function getQuickAddSheetInstance(): QuickAddSheet | null {
  return instance;
}
